import React from 'react';
import { TableRow, TableCell } from 'carbon-components-react';
import { roleMapper } from 'utilities/helper.util';
const DisplayUserRow: React.FC<any> = ({
  row,
  getRowProps,
  handleSetUserId
}: any) => {
  return (
    <>
      <TableRow
        {...getRowProps({ row })}
        onClick={() => handleSetUserId({ userId: row.id })}
      >
        <TableCell key={'email'}>{row.cells[0].value}</TableCell>
        <TableCell key={'firstName'}>
          <div>{row.cells[1].value}</div>
          <div>{row.cells[2].value}</div>
        </TableCell>
        <TableCell key={'role'}>
          {row.cells[3].value.map((r: string) => (
            <div key={r}>{roleMapper(r)}</div>
          ))}
        </TableCell>
        <TableCell key={'lastLoggedInAt'}>{row.cells[4].value}</TableCell>
      </TableRow>
    </>
  );
};
DisplayUserRow.displayName = 'DisplayUserRow';
export default DisplayUserRow;
